var gallery = {
  images: null,
  indexImages: null,
  index: -1,
  container: null
};

var openGallery = function openGallery(flexSpot, clickedImage) {
  var elements = Array.prototype.slice.call(flexSpot.querySelectorAll('.elements .element'));
  gallery.images = null;
  gallery.indexImages = Array.prototype.slice.call(elements[0].querySelectorAll('.element__item__image img'));

  if (elements.length === 1) {
    gallery.images = Array.prototype.slice.call(elements[0].querySelectorAll('.element__item__image img'));
  } else if (elements.length > 1) {
    gallery.images = Array.prototype.slice.call(elements[1].querySelectorAll('.element__item__image img'));
  }

  if (gallery.images) {
    gallery.index = gallery.indexImages.findIndex(function (img) {
      return img.src === clickedImage.src;
    });

    if (!gallery.container) {
      var container = document.createElement('div');
      container.className = 'gallery-container';
      document.body.appendChild(container);
      gallery.container = container;
    }

    gallery.container.innerHTML = "<div class=\"overlay\">\n    <div class=\"inner-container\">\n      <div class=\"prev\">&lt;</div><div class=\"image\">".concat(gallery.images[gallery.index].outerHTML.replace('data-src', 'src'), "</div><div class=\"next\">&gt;</div>\n    </div>\n    <div class=\"close\">X</div>\n  </div>");
    var prevBtn = gallery.container.querySelector('.prev');
    var nextBtn = gallery.container.querySelector('.next');
    var closeBtn = gallery.container.querySelector('.close');
    prevBtn.addEventListener('click', function () {
      gallery.index = gallery.index > 0 ? gallery.index - 1 : gallery.images.length - 1;
      gallery.container.querySelector('.image').innerHTML = gallery.images[gallery.index].outerHTML.replace('data-src', 'src');
    });
    nextBtn.addEventListener('click', function () {
      gallery.index = gallery.index < gallery.images.length - 1 ? gallery.index + 1 : 0;
      gallery.container.querySelector('.image').innerHTML = gallery.images[gallery.index].outerHTML.replace('data-src', 'src');
    });
    closeBtn.addEventListener('click', function () {
      gallery.container.innerHTML = '';
      gallery.container.className = 'gallery-container';
    });
    gallery.container.className = 'gallery-container open';
  }
};

try {
  (function () {
    var flexSpots = Array.prototype.slice.call(document.querySelectorAll('.flex-spot'));
    flexSpots.forEach(function (flexSpot) {
      var items = Array.prototype.slice.call(flexSpot.querySelectorAll('.elements .element__item'));
      var isOnlyImages = true;
      items.forEach(function (item) {
        if (!item.classList.contains('element__item__image')) {
          isOnlyImages = false;
        }
      });

      if (isOnlyImages) {
        // add gallery class to flex spot
        flexSpot.classList.add('gallery'); // add click handle on each image to open gallery

        items.forEach(function (image) {
          image.addEventListener('click', function () {
            openGallery(flexSpot, image.querySelector('img'));
          });
        });
      }
    });
  })();
} catch (error) {
  console.log(error);
}